import React from "react";
import "./AboutUsTradition.scss";

export default function AboutUsTradition({ t }) {
  return (
    <div className="about-us-tradition">
      <div className="about-us-tradition__content">
        <h1>{t("about_us_tradition_title")}</h1>
        <p>{t("about_us_tradition_description")}</p>
      </div>
    </div>
  );
}
